import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './main/auth/login/login.component';
import { SignUpComponent } from './main/auth/sign-up/sign-up.component';
import { HomePageComponent } from './main/homepage/homepage.component';
import { LicensesComponent } from './main/licenses/licenses.component';
import { UserManualComponent } from './main/user-manual/user-manual.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { DetachedLoginComponent } from './main/detached-login/detached-login.component';
import { SsoDetachedLoggedInComponent } from './main/sso-detached-logged-in/sso-detached-logged-in.component';

const routes: Routes = [
  {
    path: 'sso-logged-in',
    component: LoginComponent,
  },
  {
    path: 'customers',
    children: [
      {
        path: 'signup',
        component: SignUpComponent,
      },
    ],
  },
  {
    path: 'userManuals',
    component: UserManualComponent,
  },
  {
    path: 'home',
    component: HomePageComponent,
  },
  {
    path: 'licenses',
    component: LicensesComponent,
  },
  {
    path: 'detached-login',
    component: DetachedLoginComponent,
  },
  {
    path: 'sso-detached-logged-in',
    component: SsoDetachedLoggedInComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: 'not-found',
    component: PageNotFoundComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'homepage',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      preloadingStrategy: NoPreloading,
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
